import { useGetCohortVersionQuery } from '@verantos-dev/data-access-cohorts';
import { type CohortVersion } from '@verantos-dev/types-cohorts';
import { type ObjectResponse } from '@verantos-dev/types-common';

export const useCohortVersionData = (
  projectId: string | undefined,
  cohortId: string | null,
  cohortVersionId: string | null
) => {
  const { data: sourceCohortVersion, isLoading: isCohortVersionLoading } = useGetCohortVersionQuery(
    {
      projectId: projectId || '',
      cohortId: cohortId || '',
      cohortVersionId: cohortVersionId || '',
    },
    { skip: !cohortId || !projectId || !cohortVersionId }
  );

  return {
    sourceCohortVersion: sourceCohortVersion as ObjectResponse<CohortVersion> | undefined,
    isCohortVersionLoading,
  };
};
